<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 2C7 1.44772 7.44772 1 8 1H12C12.5523 1 13 1.44772 13 2C13 2.55228 12.5523 3 12 3H8C7.44772 3 7 2.55228 7 2ZM10 20C14.4183 20 18 16.4183 18 12C18 10.1513 17.3729 8.44904 16.3199 7.09436L17.2071 6.20711C17.5976 5.81658 17.5976 5.18342 17.2071 4.79289C16.8166 4.40237 16.1834 4.40237 15.7929 4.79289L14.9056 5.68014C13.551 4.62708 11.8487 4 10 4C5.58172 4 2 7.58172 2 12C2 16.4183 5.58172 20 10 20ZM10 6C9.44772 6 9 6.44772 9 7V11C9 11.5523 9.44772 12 10 12C10.5523 12 11 11.5523 11 11V7C11 6.44772 10.5523 6 10 6Z"
  />
</svg>
